// @flow
import * as React from 'react';
import styled from 'styled-components';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import PageHeading from '../Common/PageHeading';
import Typography from '../Common/Typography';
import TextBox from '../Common/TextBox';
import { Button } from '../Common/Button';
import ErrorAlert from '../Common/ErrorAlert';
import { useInterval } from '../../hooks';
import atLeast from '../../styling/atLeast';

const Body = styled.div`
  padding: 1rem;
`;

const StyledTextBox = styled(TextBox)`
  width: 100%;

  ${atLeast.small`
    max-width: 350px;
  `}
`;

const ButtonContainer = styled.div`
  margin-top: 1rem;

  button:first-child {
    margin-right: 0.5rem;
  }
`;

type Props = {
  code: string,
  verificationType: number,
  verificationDetails: string,
  errors: Array<string>,
  aborting: boolean,
  onChange: (SyntheticKeyboardEvent<HTMLInputElement>) => mixed,
  onCancel: () => void,
  onSubmit: (SyntheticEvent<HTMLButtonElement>) => mixed
};

const VerifyLoginDisplay = (props: Props) => {
  const [seconds, setSeconds] = React.useState<number>(3);

  React.useEffect(() => {
    if (seconds === 0) {
      window.location.href = window.origin;
    }
  }, [seconds]);

  useInterval(() => {
    if (props.aborting) setSeconds(Math.max(0, seconds - 1));
  }, 1000);

  return (
    <>
      <PageHeading>
        <Typography kind="h3">Verify Login</Typography>
        <FontAwesomeIcon icon="key" size="lg" />
      </PageHeading>
      <Body>
        <ErrorAlert errors={props.errors} />
        {props.aborting ? (
          <>
            {seconds === 0 ? (
              <p>Redirecting to login....</p>
            ) : (
              <p>
                You will be redirected to the login page in {seconds} seconds.
              </p>
            )}
          </>
        ) : (
          <>
            {props.verificationType === 1 ? (
              <p>
                An email has been sent to {props.verificationDetails}, please
                check your inbox and enter the 6 digit verification code below
              </p>
            ) : (
              <p>
                An SMS has been sent to your mobile number ending in{' '}
                {props.verificationDetails}, please enter the 6 digit
                verification code below
              </p>
            )}
            <form onSubmit={props.onSubmit}>
              <StyledTextBox
                type="text"
                autoFocus
                placeholder="Enter verification code"
                value={props.code}
                onChange={props.onChange}
              />

              <ButtonContainer>
                <Button kind="secondary" type="button" onClick={props.onCancel}>
                  Cancel
                </Button>
                <Button kind="primary" type="submit">
                  Submit
                </Button>
              </ButtonContainer>
            </form>
          </>
        )}
      </Body>
    </>
  );
};

export default VerifyLoginDisplay;
